import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-con2',
  templateUrl: './e-con2.component.html',
  styleUrls: ['./e-con2.component.css']
})
export class ECon2Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
